// JOBE-0044.13: GenericAttributesPreview — fallback preview for kinds
// without a registered per-kind component (and without
// `structuralShape: document` on their entity-type row).
//
// Renders a header (name + kind + owner) followed by a simple
// key/value attribute list pulled from the EntityRow payload. Empty /
// null values omit the row entirely — no em-dash placeholders, no
// clutter (per spec §"GenericAttributesPreview specifics").

import { relTime, urnSlug } from '../../../lib/relTime.js';

function AttrRow({ label, children }) {
  return (
    <div className="library-inspector-attr-row">
      <dt className="library-inspector-attr-label">{label}</dt>
      <dd className="library-inspector-attr-value">{children}</dd>
    </div>
  );
}

export function GenericAttributesPreview({ entity }) {
  if (!entity) return null;

  const ownerLabel = entity.owner?.displayName
    || entity.owner?.name
    || urnSlug(entity.owner?.urn || '')
    || null;
  const projectLabel = entity.project?.name
    || urnSlug(entity.project?.urn || '')
    || null;
  const collectionNames = Array.isArray(entity.collections)
    ? entity.collections
      .map((c) => c?.name || urnSlug(c?.urn || ''))
      .filter(Boolean)
    : [];

  return (
    <section className="library-inspector-preview library-inspector-generic-preview">
      <header className="library-inspector-header">
        <h3 className="library-inspector-name">
          {entity.name || urnSlug(entity.urn) || 'Untitled'}
        </h3>
        <div className="library-inspector-meta">
          {entity.kind && (
            <span className="library-inspector-kind">{entity.kind}</span>
          )}
          {ownerLabel && (
            <span className="library-inspector-owner" title={entity.owner?.urn || ''}>
              {ownerLabel}
            </span>
          )}
        </div>
        <div className="library-inspector-urn" title={entity.urn}>{entity.urn}</div>
      </header>

      <dl className="library-inspector-attrs">
        {entity.kind && <AttrRow label="kind">{entity.kind}</AttrRow>}
        {entity.summary && (
          <AttrRow label="summary">{entity.summary}</AttrRow>
        )}
        {ownerLabel && (
          <AttrRow label="owner">{ownerLabel}</AttrRow>
        )}
        {projectLabel && (
          <AttrRow label="project">{projectLabel}</AttrRow>
        )}
        {collectionNames.length > 0 && (
          <AttrRow label="collections">{collectionNames.join(', ')}</AttrRow>
        )}
        {entity.lastChangedAt && (
          <AttrRow label="updated">
            <span title={entity.lastChangedAt}>{relTime(entity.lastChangedAt)}</span>
          </AttrRow>
        )}
      </dl>
    </section>
  );
}
